<div class="container">
    <h3 mat-dialog-title>Referencje</h3>
    <div mat-dialog-content>
        <table mat-table [dataSource]="data">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Id </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nazwa </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button (click)="onNoClick()" tabindex="-1">Zamknij</button>
    </div>
</div>
